import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Container } from '@material-ui/core';
import { useTrackedState } from '../../store/Auth';
import useAuthActions from '../../hooks/useAuthActions';
import EnterConfirmationCodeForm from '../enterConfirmationCodeForm/EnterConfirmationCodeForm';
import ForgotPasswordForm from '../forgotPasswordForm/ForgotPasswordForm';
import LoginForm from '../loginForm/LoginForm';
import routes from '../router/routes';
import SetNewPwForm from '../setNewPwForm/SetNewPwForm';

const Admin = (): JSX.Element => {
  const {
    user,
    passwordResetNeeded,
    forgotPasswordCodeSent,
    forgotPassword,
  } = useTrackedState();
  const { checkSession } = useAuthActions();
  const history = useHistory();

  // on load, check auth session
  React.useEffect(() => {
    checkSession();
  }, [checkSession]);

  // if user is logged in, send him to app route
  React.useEffect(() => {
    if (user) {
      history.push(routes.app.menuManagement);
    }
  }, [user, history]);

  const renderForm = () => {
    if (forgotPasswordCodeSent) {
      return <EnterConfirmationCodeForm />;
    }

    if (forgotPassword) {
      return <ForgotPasswordForm />;
    }

    if (passwordResetNeeded) {
      return <SetNewPwForm />;
    }

    return <LoginForm />;
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="90vh"
      >
        <Box p={4}>{renderForm()}</Box>
      </Box>
    </Container>
  );
};

export default Admin;
